export default __webpack_public_path__ + "static/media/activity_bell.2f76f925.svg";